import React from 'react';

const Footer = () => {
    return (
        <div className="footer-page">
            <div className="col-md-11 col-12 p-0 d-flex justify-content-between m-auto">
                <div className="dashboard-image">
                    <img src="https://res.cloudinary.com/teewhy/image/upload/v1562151644/WificomngLogo.png" alt="logo"
                         width="50%"/>
                </div>

                <div>
                    <p><b>Connect with us</b></p>
                    <div className="social-icons d-flex mt-2">
                        <div className="mr-auto links">
                             <a href="https://x.com/freefiberafrica/" target="_blank" rel="noopener noreferrer"> <i className="fa fa-twitter"></i></a>
                           
                        </div>

                        <div className="mr-auto links">
                            <a href="https://www.facebook.com/freefiberafrica/" target="_blank" rel="noopener noreferrer"><i className="fa fa-facebook"></i></a>
                            
                        </div>

                        <div className="mr-auto links">
                            <a href="https://www.instagram.com/freefiberafrica/" target="_blank" rel="noopener noreferrer"><i className="fa fa-instagram"></i></a>
                            
                        </div>

                        <div className="mr-auto links">
                            <a href="https://www.linkedin.com/company/tizeti/" target="_blank" rel="noopener noreferrer"><i className="fa fa-linkedin"></i></a>
                            
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default Footer;